
import Vue from "vue";
import { ExtraFieldNamesConfig } from "@/models/dossier-configs/extra-field-names-config";
import { ExtraFieldTabConfig } from "@/models/dossier-configs/extra-field-tab-config";
import { IExtraFields } from "@/utils/models/extra-fields";
import AppExtraFieldsEdit from "@/components/ExtraFieldsEdit.vue";
import AppExtraFieldsInfo from "@/components/ExtraFieldsInfo.vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => IExtraFields | null
		},
		tab: {
			type: Object as () => ExtraFieldTabConfig,
			required: true
		},
		nameSettings: {
			type: Object as () => ExtraFieldNamesConfig,
			required: true
		},
		readonly: Boolean
	},
	components: {
		AppExtraFieldsEdit,
		AppExtraFieldsInfo
	}
});
